module.exports = __webpack_public_path__ + "img/dev.46b23038.png";